import { signal } from '@angular/core';

export interface MapRecenterEvent {
  lat: number;
  lng: number;
  timestamp: number;
}

class MapEventsState {
  // Signal for map recenter requests
  private recenterRequestSignal = signal<MapRecenterEvent | null>(null);
  
  // Public readonly computed for components to react to
  readonly recenterRequest = this.recenterRequestSignal.asReadonly();
  
  // Method to request map recenter
  requestRecenter(coords: { lat: number; lng: number }) {
    console.log('🗺️ Map recenter requested:', coords);
    this.recenterRequestSignal.set({
      ...coords,
      timestamp: Date.now()
    });
  }
  
  // Method to clear recenter request (after handling)
  clearRecenterRequest() {
    this.recenterRequestSignal.set(null);
  }
}

export const mapEventsState = new MapEventsState();
